import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useProspectSelector() {
  const ProspectGrid = useSelector((state) => state.Prospect.prospect_grid) || {}; // Prospect grid data
  const ProspectListData = useSelector((state) => state.Prospect.prospect_list) || {}; // Prospect list data
  const ProspectViewData = useSelector((state) => state.Prospect.view_data) || {}; // Prospect list data

  const ProspectListDrop = useMemo(
    () =>
      (ProspectListData?.prospectStatuses || [])?.map((item) => ({
        label: item?.stageStatusName,
        value: item?.stageStatusId
      })),
    [ProspectListData]
  );

  return { ProspectGrid, ProspectListData, ProspectListDrop, ProspectViewData };
}
